import {use, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AlertMessage from "../components/AlertMessage";

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState<{ type: "error" | "success"; text: string } | null>(null);
    const [showSignup, setShowSignup] = useState(false);

    const handleSignupClick = (e: React.MouseEvent) => {
        e.preventDefault();
        setShowSignup(true);
    };

    useEffect(() => {
        console.log(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`);
    }, []);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/auth/login`,
                {email, password},
                {withCredentials: true}
            );

            if (res.data.user) {
                localStorage.setItem("user", JSON.stringify(res.data.user));
            }

            if (res.data.token) {
                localStorage.setItem("token", res.data.token);
            } else {
                console.error("No token received!");
            }

            // Redirect based on user role
            const userRole = res.data.user.role;
            let redirectUrl = "/login";
            if (userRole === "admin") {
                redirectUrl = "/admin/dashboard";
            }

            navigate(redirectUrl);
        } catch (err) {
            setMessage({type: "error", text: "Invalid email or password"});
        }
    };

    return (
        <div className="login-container">
            <main className="main">

                <div className="ls-box">
                    <div className="ls-header">
                        <h2 className={!showSignup ? "ls-active" : "ls-inactive"}>
                            <a onClick={() => setShowSignup(false)} style={{textDecoration: "none"}}>Login</a>
                        </h2>
                        <h2 className={showSignup ? "ls-active" : "ls-inactive"}>
                            <a onClick={handleSignupClick} style={{textDecoration: "none"}}>Sign up</a>
                        </h2>
                    </div>
                    <AlertMessage type={message?.type || "error"} message={message?.text || ""}/>
                    {!showSignup ? (
                        <form onSubmit={handleLogin} className="ls-form">
                            <div>
                                <i className="bi bi-envelope"></i>
                                <input type="text" name="email" placeholder="E-Mail" value={email}
                                       onChange={(e) => setEmail(e.target.value)} required/>
                            </div>
                            <div>
                                <i className="bi bi-shield-lock"></i>
                                <input type="password" name="password" placeholder="Password" value={password}
                                       onChange={(e) => setPassword(e.target.value)} required/>
                            </div>
                            <div className="ls-buttons">
                                <a href="/forgotPassword" id="ls-fyp">Forgot your password?</a>
                                <button type="submit">Login</button>
                            </div>
                        </form>
                    ) : (
                        <div className="s-form">
                            <a>To sign up / password reset <br/>please contact:<br/></a>
                            <a href="mailto: info@lucasbrand.de">info@lucasbrand.de</a>
                        </div>
                    )}
                </div>
                <img src="/pics/logo/sec/dd_logo_only_colors_sec.svg" alt="Logo" id="wing"/>
            </main>
        </div>
    );
};

export default Login;